import { UmpireReportChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const UmpireGamePerformanceChartSidebar = (props: ChartConfigProps<TableChartConfigDto, UmpireReportChartConfigDto>) => {
  return <TableChartSidebar chartId='UmpireGamePerformanceChart' configKey='umpireGamePerformanceChartConfig' {...props} />;
};

export default UmpireGamePerformanceChartSidebar;
